/**
 * ワークフロー一覧・詳細の定期再取得間隔 (30 秒)。
 *
 * spec AC-WFW-039 (`docs/specs/workflow/workflow.md` §機能仕様): 表示中のワーク
 * フロー一覧・詳細を一定間隔で自動再取得し、他ユーザーの操作 (実行者の完了 →
 * 承認要求の発生、承認者の承認 → 次サブステップへの進行) を、手動リロードなしで
 * 画面へ反映する。再取得の間隔値・実装方式は EN 判断範囲 (spec 同 AC の注記)。
 *
 * 30 秒に決めた根拠 (Design Note `tmp/designing-feature/workflow-auto-update.md`
 * D4、2026-08-24 EN 確定):
 *
 * - 最も業務が近い先行実装 (同じ承認ドメインの承認案件一覧 `AdminApprovalTasks`、
 *   `useListApprovalTasks.ts` の `refetchInterval: 30_000`) が 30 秒 (spec 非機能
 *   要件)。
 * - 承認の受け渡しリードタイムは当日運用で「分単位」であり (spec L941)、市場系
 *   (入札板・約定履歴・同時同量。`HISTORY_REFETCH_INTERVAL_MS` = 5 秒) と同じ間隔
 *   では一覧 (全ケース + 導出列再計算) への負荷が過大。気象データ用の 120 秒
 *   (`hooks/weather/refetchInterval.ts` の `WEATHER_REFETCH_INTERVAL_MS`) は
 *   データソース (BigQuery / 気象庁更新頻度) 都合の値で本ドメインとは無関係。
 *
 * 一覧 (`useListWorkflowCases`) と詳細 (`WorkflowCaseDetail` が呼ぶ
 * `useGetWorkflowCase`) で共通の値を使う。
 */
export const WORKFLOW_CASE_REFETCH_INTERVAL_MS = 30 * 1000
